import { Button, Card, MonoLabel } from '@/design-system';
import type { PlanningSuggestion } from '@/entities/order';

import { planningCopy } from '../copy';

export interface AdviceBarProps {
    suggestion: PlanningSuggestion;
    busy: boolean;
    onApply: (suggestion: PlanningSuggestion) => void;
}

/**
 * De adviesbalk meldt geen "214 km", maar wát er moet verschuiven, waarheen en
 * wat dat oplevert - met één knop die het doet (principe 7). De zin komt van de
 * API, zodat app en dashboard hetzelfde zeggen.
 */
export function AdviceBar({ suggestion, busy, onApply }: AdviceBarProps) {
    return (
        <Card
            variant="warn"
            padding="none"
            role="region"
            aria-label={planningCopy.adviceLabel}
            className="mb-[14px] flex flex-wrap items-center gap-[14px] px-4 py-[14px]"
        >
            <span aria-hidden="true" className="h-2 w-2 shrink-0 rounded-full bg-[var(--warn)]" />
            <p className="m-0 min-w-[220px] flex-1 text-[14px] leading-[1.45] text-[var(--warn-ink)]">
                {suggestion.label}
            </p>
            <MonoLabel size={11} variant="value" tone="default">
                {planningCopy.adviceSaved(suggestion.savedKilometres)}
            </MonoLabel>
            <Button variant="warn" size="sm" disabled={busy} onClick={() => onApply(suggestion)}>
                {busy ? planningCopy.adviceApplying : planningCopy.adviceApply}
            </Button>
        </Card>
    );
}
